module.exports = __webpack_public_path__ + "42e66db557f96e9b289a96f8465e7f01.svg";